export const actorResourceTypes = Object.freeze({
  integer: 1,
  boolean: 2,
  string: 3,
  float: 4,
});
